// extracted by mini-css-extract-plugin
module.exports = {"actions":"HeaderFavorite_actions__bM9vu","actionButton":"HeaderFavorite_actionButton__Xz1Pr"};